import React from 'react'
import { FaArrowRight, FaStar } from 'react-icons/fa'
function CCD_Review_Program_Page() {
  return (
    <div>
      <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center review_component_text'>
                <h1 className='display-5 pb-2'>Testmonial</h1>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp'>
                    <div className='mt-5 px-5 review_component_text'>
                        <h1 className='pt-5 display-6'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Kranti kumari</h5>
                    <h6 class="font-weight-bold my-2">IGNOU University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Grateful for the enriching experience at InternsElite during my 3-month internship. Expertly applying C, C++, and DSA in projects.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Sachin Gupta</h5>
                    <h6 class="font-weight-bold my-2">IIIT-Delhi, Electronics and VLSI Engineering</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Through this training, I sharpened my skills in C++, a versatile programming language. I can now write more efficient and optimized code, leveraging C++ features to enhance the performance of my programs.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Anushka Raj</h5>
                    <h6 class="font-weight-bold my-2">Graphic Era Deemed to Be University BBA</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>Grateful to InternsElite for an outstanding C, C++ with DSA course. The depth, organization, and practical examples enriched my learning, ensuring valuable skills for my career. Kudos for consistently delivering top-notch education.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Raj Shekhar Singh</h5>
                    <h6 class="font-weight-bold my-2">Lucknow University</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>It was a great experience with Internselite which gave me an opportunity to do a internship with it. The internship program was very good and nice Internselite were very helpful to me throughout my whole internship program. 
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Nalamekala Sindhu</h5>
                    <h6 class="font-weight-bold my-2">Annamacharya Institute of Technology and Sciences,Tirupati, CSE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Internsellite's team demonstrated exceptional dedication, delivering high-quality results with professionalism and adaptability. Their impact on our project's success is commendable, making the collaboration a valuable experience.
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Vedant Vishal Trivedi</h5>
                    <h6 class="font-weight-bold my-2">SNJB'S College of Engineering, CS</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Complete training was really good and got to learn many things, also the soft skills sessions was really helpful to build a successful career.
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default CCD_Review_Program_Page
